import { FC } from 'react';
import {
  CreateButton,
  Datagrid,
  EditButton,
  List,
  ReferenceField,
  TextField,
  TopToolbar,
} from 'react-admin';

const ListActions = () => (
  <TopToolbar>
    <CreateButton label="Добавить материал" />
  </TopToolbar>
);

export const MaterialTestsList: FC = () => (
  <List title="Список материалов" filter={{}} actions={<ListActions />}>
    <Datagrid rowClick="show">
      <TextField source="id" label="ID" />
      {/* <TextField source="feed_id" label="ID" /> */}
      <ReferenceField source="feed_id" reference="feeds" label="Лента">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="name" label="Название" />
      <EditButton label="Редактировать" />
    </Datagrid>
  </List>
);
